// Detect element viewport
// Created: 05/2018
// Updated: -
// Note: Detect if an element is entirely visible in the viewport. If not, classes are added

'use strict';

(function($) {
	
	$.fn.elementViewport = function() {
		
		const array = this;
		let arrayStyleInitial = [];
		const arrayClasses = ['elementViewport-is_initialized', 'align-from-top', 'align-from-right', 'align-from-bottom', 'align-from-left', 'align-full-width'];

		const init = function(element, index){		
			let	element_top = element.getBoundingClientRect().top,
			element_bottom = element.getBoundingClientRect().bottom,
			element_left = element.getBoundingClientRect().left,
			element_right = element.getBoundingClientRect().right,
			element_width = element.clientWidth,
			elementLeftInitial = window.getComputedStyle( element ).left,
			outset = ( !!element.getAttribute( 'data-outset') )? parseInt( element.getAttribute( 'data-outset') ) : 0;

			element.classList.remove('elementViewport-is_initialized');
			
			var viewport_top = 0,
			viewport_bottom = document.body.clientHeight,
			viewport_left = 0,
			viewport_right = document.body.clientWidth,
			viewport_width = document.body.clientWidth;

			if( element_left < 0 ){
				for(let i = 0; i <= arrayClasses.length; i++ ){
					element.classList.remove( arrayClasses[i] );
				}
				element.classList.add('align-from-left');
				element.setAttribute('style', `${arrayStyleInitial[index]} margin-left: ${( viewport_left - element_left) + outset}px`);
			}else if( element_right > viewport_width ){
				for(let i = 0; i <= arrayClasses.length; i++ ){
					element.classList.remove( arrayClasses[i] );
				}
				element.classList.add('align-from-right');
				element.setAttribute('style', `${arrayStyleInitial[index]} margin-left: -${(element_right - viewport_width ) - outset}px`);
			}
			else if ( element_width >= viewport_width ) {
				for(let i = 0; i <= arrayClasses.length; i++ ){
					element.classList.remove( arrayClasses[i] );
				}
				element.classList.add('align-full-width');

				element.setAttribute( 'style',
					`
					${arrayStyleInitial[index]}
					margin-left: - ${( element_left - outset )}
					width: viewport_width - ${( outset * 2 )}
					`
				);
			}
			
			element.classList.add('elementViewport-is_initialized');
		}

		const destroy = function(element, index){
			element.setAttribute('style', arrayStyleInitial[index]);
			for(let i = 0; i <= arrayClasses.length; i++ ){
				element.classList.remove( arrayClasses[i] );
			}
		}

		$(window).on('resize.elementViewport', _.throttle( function(){
			array.each( function(index){
				destroy(array[index], index);
				init(array[index], index);
			});
		}, 200));

		array.each(function(index){
			var style = ( this.getAttribute('style') == null ) ? '' : this.getAttribute('style');
			
			arrayStyleInitial.push( style );
			init(this, index);
		});

		
	}
})(jQuery);